import React from 'react';

const About: React.FC = () => {
    return (
        <main id="main-content" className="w-full bg-canvas" role="main">
            {/* Page Title */}
            <section className="pt-32 pb-16 px-6 md:px-16 lg:px-24 text-center">
                <h1>About</h1>
            </section>

            {/* Content */}
            <section className="pb-[191px] px-6 md:px-12 lg:px-24">
                <div className="max-w-2xl mx-auto px-6 space-y-8 text-left">
                    <p className="text-balance leading-relaxed">
                        SilentLabs is a technology and research company.<br />Our mission is to design and develop tools that adapt to humans.
                    </p>
                    <p className="text-balance leading-relaxed">
                        With the rapid developments of recent years, visions about technology that learns and adapts to us are becoming reality. Artificial intelligence, in particular, has enabled capabilities that weren't possible before — where technology is no longer something to learn, but something that can learn us, and assist in a way that feels effortless and intuitive.
                    </p>
                </div>
            </section>
        </main>
    );
};

export default About;
